import { required } from 'vuelidate/lib/validators';

import BaseValidation from '@/forms/Validations/BaseValidation';
import NameValidation from '@/forms/FormElements/Rows/NameRow/NameRow.validation';
import EmailValidation from '@/forms/FormElements/Rows/EmailRow/EmailRow.validation';
import AddressValidation from '@/forms/FormElements/Rows/AddressRow/AddressRow.validation';
import PhoneValidation from '@/forms/FormElements/Rows/PhoneRow/PhoneRow.validation';

import { names } from './ContestForm.types';

const barcodeIsValid = (value) => !isNaN(+value) && value >= 9001001 && value <= 9001649;

const barcodeValidation = new BaseValidation([
  {
    name: names.Barcode,
    rules: { required, barcodeIsValid },
    messages: {
      required: 'Enter a Barcode number',
      barcodeIsValid: 'Barcode number is not valid',
    },
  },
]);

const agencyValidation = new BaseValidation([
  {
    name: names.Agency,
    rules: { required },
    messages: {
      required: 'Enter an Agency name',
    },
  },
]);

const tagValidation = new BaseValidation([
  {
    name: names.Tag,
    rules: { },
    messages: { },
  },
]);

export default () => {
  const validations = [
    NameValidation(names.Person),
    EmailValidation(names.Person),
    AddressValidation(names.Address),
    PhoneValidation(names.Phone),
    barcodeValidation,
    agencyValidation,
    tagValidation,
  ];

  return {
    validations: BaseValidation.getRules(validations),
    messages: BaseValidation.getMessages(validations),
    model: BaseValidation.getModel(validations),
  };
};
